var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector25(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 309,
    viewBox: "0 0 152 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.983 307.546C304.594 288.631 300.888 284.512 286.072 265.103C282.441 260.348 276.73 251.104 271.275 239.687C269.64 236.27 268.158 232.882 266.799 229.541C257.105 205.634 255.736 178.851 257.989 152.4C263.738 84.911 227.207 23.9991 171.895 6.24177C116.489 -11.544 54.9631 17.7161 24.9412 63.3764C21.0352 69.3176 3.80515 97.3535 1.25819 128.113C-6.81038 225.233 87.2659 264.04 230.409 293.424C233.194 293.993 246.451 296.167 249.264 296.556L327.992 307.556L327.983 307.546Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector25);
export default __webpack_public_path__ + "static/media/vector2-5.ad65f4518354b5d009a1dca60a98f7f9.svg";
export { ForwardRef as ReactComponent };